import { render, staticRenderFns } from "./CallControlSection.vue?vue&type=template&id=3f47bef7&scoped=true"
import script from "./CallControlSection.vue?vue&type=script&lang=js"
export * from "./CallControlSection.vue?vue&type=script&lang=js"
import style0 from "./CallControlSection.vue?vue&type=style&index=0&id=3f47bef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47bef7",
  null
  
)

export default component.exports